export default "__VITE_ASSET__BpfAAy6i__"